import { createStore } from 'vuex'
import user from './user'
import menu from './menu'

export default createStore({
  state: {
    ...user.state,
    ...menu.state
  },
  getters: {
    ...user.getters,
    ...menu.getters
  },
  mutations: {
    ...user.mutations,
    ...menu.mutations
  },
  actions: {
    ...user.actions,
    ...menu.actions,
    removeAll() {
      this.commit('removeToken');
      this.commit('removeMenu');
    }
  },
  modules: {
  }
});
